<template lang="pug">
  .row
    .col-lg-6
      .d-flex.flex-row.align-items-center
        font-awesome-icon.account-page__icon(:icon=['far', 'lock-alt'])
        h3.account-page__title {{ trans('labels.frontend.user.passwords.change') }}
      form.mb-3(@submit.prevent='onSave')
        .row
          .col-12
            .form-group.form-group--required(:class="{ 'form-group--error': $v.user.password.$error }")
              label.control-label(for='password') {{ trans('labels.frontend.user.passwords.new_password') }}
              input.form-control(
                type='password'
                id='password'
                name='password'
                maxlength='199'
                :placeholder="trans('labels.frontend.user.passwords.new_password')"
                v-model.trim="$v.user.password.$model"
              )
        .row
          .col-12
            .form-group.form-group--required(:class="{ 'form-group--error': $v.user.password_confirmation.$error }")
              label.control-label(for='password_confirmation') {{ trans('labels.frontend.user.passwords.new_password_confirmation') }}
              input.form-control(
                type='password'
                id='password_confirmation'
                name='password_confirmation'
                maxlength='199'
                :placeholder="trans('labels.frontend.user.passwords.new_password_confirmation')"
                v-model.trim="$v.user.password_confirmation.$model"
              )
        button.btn.btn-primary.btn-md.btn-long-md(type='button' disabled="disabled" v-if="$wait.is('changing password')")
          font-awesome-icon(:icon="['far', 'circle-notch']" spin).mr-2
          | {{ trans('alerts.general.sending_request') }}
        button.btn.btn-primary.btn-md.btn-long-md(
          type='submit'
          :disabled="$v.$invalid"
          v-if="!$wait.is('changing password')"
        ) {{ trans('labels.frontend.user.passwords.change') }}
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import notify from '../../../components/notify';

export default {
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.user.passwords.change'),
    };
  },
  mixins: [BreadcrumbsManager, validationMixin],
  data() {
    return {
      user: {
        password: '',
        password_confirmation: '',
      },
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('labels.frontend.user.passwords.change') },
    ]);
  },
  methods: {
    async onSave() {
      this.$wait.start('changing password');
      notify.loading(this, { title: Lang.get('alerts.general.sending_request'), text: false });
      try {
        await this.$store.dispatch('account/change_password', this.user);
        this.user.password = '';
        this.user.password_confirmation = '';
        this.$v.$reset();
        notify.clean(this).then(() => notify.success(this, { title: Lang.get('alerts.general.operation_completed') }));
      } catch (err) {
        notify.clean(this).then(() => notify.errors(this, err));
      }
      this.$wait.end('changing password');
    },
  },
  validations: {
    user: {
      password: {
        required,
        minLength: minLength(8),
      },
      password_confirmation: {
        required,
        minLength: minLength(8),
        sameAsPassword: sameAs('password'),
      },
    },
  },
};
</script>
